export const orderSummmaryApi = {
  getCoupons: async (client, {country, coupon}) => {
    const response = await client(
      `cc/order/fetchCoupons/${encodeURIComponent(
        country,
      )}/${encodeURIComponent(coupon)}`,
      {
        method: 'GET',
      },
    )
    return response
  },
}
